<template>
  <div class="fire-platform-page">
    <!-- 1. Banner首屏区域 -->
    <section class="banner-section scroll-fade">
      <div class="banner-left">
        <div class="tag">智慧消防技术领军企业</div>
        <h1 class="main-title">
          消防远程监控<br>
          <span class="color-text">云平台解决方案</span>
        </h1>
        <p class="desc">
          直击传统消防控制室双人值守成本高、缺人脱岗、响应慢、管理乱等痛点，依托物联网、云计算与AI智能研判技术，打造合规高效的消防单人值守智慧云平台。
        </p>
        <div class="btn-group">
          <!-- 绑定点击事件 -->
          <button class="btn primary-btn" @click="openApply">了解详情 <span>→</span></button>
          <button class="btn outline-btn" @click="openApply">
            <span class="play-icon">▶</span> 免费试用
          </button>
        </div>
        <div class="bottom-info">
          <div class="info-item">
            <div class="info-item-group">
              <div><span></span></div>
              <div><span></span></div>
              <div><span></span></div>
              <div><span></span></div>
              <div><span></span></div>
            </div>
            <span>3000+ 企业信赖</span>
          </div>
          <div class="info-item">
            <span class="star">★★★★★</span>
            <span>行业好评率 99%</span>
          </div>
        </div>
      </div>
      <div class="banner-right">
        <div class="cube-box">
          <div class="img-placeholder">
            <img
                class="banner-img"
                src="https://xf.hoyaostar.com:9527/assets/login-banner-DaLus7Zc.png"
                alt="消防远程值守云平台">
          </div>
          <div class="tip-tag tip-left">
            <span class="green-check">
              <i class="el-icon-cpu"></i>
            </span>
            <div>
              <div>AI识别准确率</div>
              <div class="num">99.5%</div>
            </div>
          </div>
          <div class="tip-tag tip-right">
            <span class="orange-light">
              <i class="el-icon-warning"></i>
            </span>
            <div>
              <div>预警响应速度</div>
              <div class="num">3秒级</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2. 四大核心能力区域 -->
    <section class="core-ability-section scroll-fade">
      <div class="section-header">
        <div class="section-tag">● 核心优势</div>
        <h2 class="section-title">四大核心层级，构建<span class="blue-text">智慧消防一体化体系</span></h2>
        <p class="section-sub">
          以多层级软硬件架构为底座，打通前端感知、边缘汇聚、AI
          智能研判、云端综合管控全链路，构建全方位、高效率、低成本的智慧消防解决方案。</p>
      </div>
      <div class="ability-list">
        <div class="ability-card" v-for="item in abilityData" :key="item.num">
          <div class="icon" :class="item.iconClass">
            <i :class="item.icon"></i>
          </div>
          <div class="num">{{ item.num }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 技术优势   -->
    <section class="function-section scroll-fade">
      <div class="section-header">
        <div class="section-tag">● 技术优势</div>
        <h2 class="section-title">算力、算法、平台、应用协同<span class="color-text">四大核心技术引擎</span></h2>
        <p class="section-sub">从预警识别到云端管理，从值守服务到应急处置，打造端到端的智慧消防远程值守一体化平台</p>
      </div>
      <div class="tech-container">
        <el-row :gutter="24">
          <!-- 左侧模块列表 -->
          <el-col :span="10">
            <div class="left-list">
              <div
                  v-for="(item, index) in moduleList"
                  :key="index"
                  class="module-card"
                  :class="{ active: activeIndex === index }"
                  @click="activeIndex = index"
              >
                <div class="card-icon" :style="{background: item.iconBg}">
                  <i :class="item.icon"></i>
                </div>
                <div class="card-content">
                  <div class="card-title">{{ item.title }}</div>
                  <div class="card-desc">{{ item.desc }}</div>
                </div>
                <div class="card-tag">{{ item.tag }}</div>
              </div>
            </div>
          </el-col>
          <!-- 右侧详情面板 -->
          <el-col :span="14">
            <div class="right-panel">
              <div class="panel-header">
                <h2 class="panel-title">{{ currentModule.title }}</h2>
                <p class="panel-desc">{{ currentModule.desc }}</p>
              </div>
              <div class="panel-visual">
                <img :key="activeIndex" :src="currentModule.img" :alt="currentModule.title">
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 4. 应用场景 -->
    <section class="scene-section scroll-fade">
      <div class="section-header">
        <div class="section-tag">● 应用场景</div>
        <h2 class="section-title">全行业覆盖，<span class="pink-text">多场景智慧守护</span></h2>
        <p class="section-sub">针对不同行业场景特点，提供定制化智慧消防解决方案，全面守护人员生命与财产安全</p>
      </div>
      <div class="scene-list">
        <div class="scene-card" v-for="item in sceneList" :key="item.title">
          <div class="scene-icon">
            <i :class="item.icon"></i>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
      <div class="scene-more">
        <div>更多行业场景，欢迎咨询定制解决方案</div>
        <div>
          <button class="btn primary-btn" @click="openApply">了解详情 <span>→</span></button>
        </div>
      </div>
    </section>

    <!-- 5. 数据实力板块 【仅修改此处】 -->
    <section class="data-section scroll-fade" ref="dataSection">
      <div class="section-header white-text">
        <div class="section-tag">● 数据实力</div>
        <h2 class="section-title">用数据说话，见证<span style="color: white">品牌实力</span></h2>
        <p class="section-sub">深耕智慧消防领域多年，服务全国数千家企业，守护亿万人民生命财产安全</p>
      </div>
      <div class="data-list">
        <div class="data-card">
          <div class="big-num">{{ numData[0].show }}</div>
          <div class="data-label">服务企业数</div>
        </div>
        <div class="data-card">
          <div class="big-num">{{ numData[1].show }}</div>
          <div class="data-label">覆盖城市数</div>
        </div>
        <div class="data-card">
          <div class="big-num">{{ numData[2].show }}</div>
          <div class="data-label">行业类型</div>
        </div>
        <div class="data-card">
          <div class="big-num">{{ numData[3].show }}</div>
          <div class="data-label">全天值守</div>
        </div>
      </div>
    </section>

    <!-- 弹窗组件：绑定ref和关闭事件 -->
    <Popover ref="popoverRef" @popover-close="onPopClose"/>
  </div>
</template>

<script>
import pingtai from "@/assets/images/平台层.png"
import suanfa from "@/assets/images/算法层.png"
import suanli from "@/assets/images/算力层.png"
import yingyong from "@/assets/images/应用层.png"
import Popover from "@/components/Popover"

export default {
  name: "FireRemoteGuardPlatform",
  components: {
    Popover
  },
  data() {
    return {
      observer: null,
      popOpen: false, // 弹窗状态标记
      numData: [
        {target: 3000, unit: "", suffix: "+", show: "0"},
        {target: 120, unit: "", suffix: "+", show: "0"},
        {target: 50, unit: "", suffix: "+", show: "0"},
        {target: 24, unit: "", suffix: "h", show: "0"},
      ],
      numberAnimated: false,
      activeIndex: 0,
      abilityData: [
        {
          num: '01',
          iconClass: 'orange-icon',
          icon: 'el-icon-video-camera',
          title: '前端感知',
          desc: '实现全面感知、实时采集与多源融合，接入烟感、消防、视频等设备，采集现场各类状态数据，输出原始信息，为上层系统提供完整可靠的底层数据源。'
        },
        {
          num: '02',
          iconClass: 'green-icon',
          icon: 'el-icon-link',
          title: '边缘接入',
          desc: '依靠边缘网关做协议适配与数据汇聚，实现多协议接入、边缘计算和数据加密，完成异构设备数据转换，安全可靠向上传输数据，打通设备与分析层链路。'
        },
        {
          num: '03',
          iconClass: 'purple-icon',
          icon: 'el-icon-cpu',
          title: 'AI分析',
          desc: '依托算法实现智能识别、风险预警与辅助决策，可识别火灾烟雾、现场异常行为，开展风险趋势预测，自动研判隐患输出预警，降低人工值守压力。'
        }, {
          num: '04',
          iconClass: 'blue-icon',
          icon: 'el-icon-data-analysis',
          title: '平台管理',
          desc: '做到一屏统览、集中监管、协助反控、高效决策，集成态势感知、数据分析、事件及运维管理，集中展示处置各类信息，全面支撑管理人员全局调度与安全决策。'
        },
      ],
      moduleList: [
        {
          title: "算力层",
          tag: "高性能算力支撑",
          icon: "el-icon-monitor",
          iconBg: "#e8f0ff",
          img: suanli,
          desc: "提供高性能、稳定可靠的算力支撑，依托 AI 服务器、GPU 算力池、存储及高速网络，为 AI 运算提供底层硬件基础。"
        },
        {
          title: "算法层",
          tag: "多算法持续迭代",
          icon: "el-icon-cpu",
          iconBg: "#e8f0ff",
          img: suanfa,
          desc: "构建算法仓库并持续迭代，集成烟火、行为、目标检测等 AI 模型，通过多模融合完成各类风险智能识别分析。"
        },
        {
          title: "平台层",
          tag: "能力开放中台",
          icon: "el-icon-data-analysis",
          iconBg: "#e8f0ff",
          img: pingtai,
          desc: "搭建数据中台实现能力开放，完成视频接入、数据治理、模型管理与运维监控，向上输出标准化服务接口。"
        },
        {
          title: "应用层",
          tag: "多场景业务落地",
          icon: "el-icon-menu",
          iconBg: "#e8f0ff",
          img: yingyong,
          desc: "面向多业务场景落地应用，覆盖消防监管、安全管理、设备运维、应急指挥，支撑业务端智能决策。"
        }
      ],
      sceneList: [
        {
          title: '商业综合体',
          icon: 'el-icon-office-building',
          desc: '商业街区一站式消防远程值守'
        },
        {
          title: '通信企业',
          icon: 'el-icon-monitor',
          desc: '机房基站全天候消防监测'
        },
        {
          title: '医疗机构',
          icon: 'el-icon-first-aid-kit',
          desc: '医养场所消防安全保障'
        },
        {
          title: '科技园区',
          icon: 'el-icon-school',
          desc: '产业园区智慧消防一体化管控'
        },
        {
          title: '公园城市',
          icon: 'el-icon-map-location',
          desc: '景区绿地火情智能预警巡查'
        },
        {
          title: '公租房项目',
          icon: 'el-icon-house',
          desc: '公寓社区消防云值守管理'
        },
        {
          title: '消防队伍',
          icon: 'el-icon-warning-outline',
          desc: '火情调度与可视化应急指挥'
        }
      ]
    }
  },
  computed: {
    currentModule() {
      return this.moduleList[this.activeIndex];
    }
  },
  mounted() {
    this.initScrollFade();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // 打开弹窗
    openApply() {
      this.$refs.popoverRef.openApplyPopup();
      this.popOpen = true;
    },
    // 子组件关闭弹窗后回调，同步状态
    onPopClose() {
      this.popOpen = false;
    },
    // 父组件主动关闭弹窗（代码中任意地方调用 this.closePopover()）
    closePopover() {
      if (this.$refs.popoverRef) {
        this.$refs.popoverRef.closeApplyPopup();
      }
    },
    animateNumber(item, duration = 1600) {
      const targetNum = item.target;
      const unit = item.unit;
      const suffix = item.suffix;
      const startTime = performance.now();

      const run = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        let currentVal = Math.floor(targetNum * easeProgress);

        let display;
        if (unit === "万") {
          display = (currentVal / 10000).toFixed(0);
        } else {
          display = currentVal.toLocaleString();
        }
        item.show = `${display}${unit}${suffix}`;

        if (progress < 1) {
          requestAnimationFrame(run);
        }
      };
      requestAnimationFrame(run);
    },

    initScrollFade() {
      const fadeElements = document.querySelectorAll('.scroll-fade');
      if (!window.IntersectionObserver) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-fade-active');
            this.observer.unobserve(entry.target);

            if (entry.target === this.$refs.dataSection && !this.numberAnimated) {
              this.numberAnimated = true;
              this.numData.forEach((item, idx) => {
                setTimeout(() => {
                  this.animateNumber(item);
                }, idx * 120);
              });
            }
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -60px 0px'
      });

      fadeElements.forEach(el => {
        this.observer.observe(el);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
/* 这里保留你原来全部的scss样式，不用改动 */
$primary: #3488f0;
$primary-dark: #2a6fd4;
$primary-light: #e8f1ff;
$text-main: #1a2233;
$text-sub: #596278;
$radius-lg: 16px;
$radius-md: 12px;
$shadow-sm: 0 2px 12px rgba(52, 136, 240, 0.08);
$shadow-md: 0 8px 24px rgba(52, 136, 240, 0.12);
$shadow-lg: 0 16px 40px rgba(52, 136, 240, 0.16);
$transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

.scroll-fade {
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 0.7s ease-out, transform 0.7s ease-out;
}

.scroll-fade-active {
  opacity: 1;
  transform: translateY(0);
}

.fire-platform-page {
  width: 100%;
  font-family: "Microsoft Yahei", "PingFang SC", sans-serif;
  color: $text-main;
  line-height: 1.6;
  background: #fff;
}

section {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 72px 24px;
  box-sizing: border-box;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;

  .section-tag {
    display: inline-block;
    padding: 6px 18px;
    background: $primary-light;
    border-radius: 20px;
    color: $primary;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 16px;
    letter-spacing: 0.5px;
  }

  .section-title {
    font-size: 32px;
    font-weight: 700;
    margin: 0 0 16px;
    line-height: 1.35;
    color: $text-main;

    .blue-text,
    .color-text {
      color: $primary;
    }

    .pink-text {
      color: #e8599c;
    }
  }

  .section-sub {
    font-size: 15px;
    color: $text-sub;
    max-width: 720px;
    margin: 0 auto;
    line-height: 1.8;
  }

  &.white-text {
    color: #fff;

    .section-tag {
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
    }

    .section-sub {
      color: rgba(255, 255, 255, 0.85);
    }
  }
}

// 通用按钮
.btn {
  padding: 13px 28px;
  border-radius: $radius-md;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all $transition;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &.primary-btn {
    background: linear-gradient(135deg, $primary 0%, #5ba0f5 100%);
    color: #fff;
    box-shadow: 0 4px 14px rgba(52, 136, 240, 0.35);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(52, 136, 240, 0.45);
    }
  }

  &.outline-btn {
    background: #fff;
    border: 1px solid rgba(52, 136, 240, 0.25);
    color: $primary;

    .play-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      background: $primary-light;
      border-radius: 50%;
      font-size: 10px;
    }

    &:hover {
      border-color: $primary;
      background: $primary-light;
    }
  }
}

// 1. Banner
.banner-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  min-height: 580px;
  max-width: 100%;
  background: linear-gradient(135deg, #eef6ff 0%, #f8fbff 45%, #fff8ee 100%);
  padding: 80px clamp(24px, 8vw, 120px);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -120px;
    right: -80px;
    width: 480px;
    height: 480px;
    background: radial-gradient(circle, rgba(52, 136, 240, 0.08) 0%, transparent 70%);
    pointer-events: none;
  }

  .banner-left {
    flex: 1;
    max-width: 540px;
    position: relative;
    z-index: 1;

    .tag {
      background: rgba(255, 255, 255, 0.9);
      padding: 8px 20px;
      border-radius: 30px;
      font-size: 12px;
      color: $text-sub;
      display: inline-block;
      margin-bottom: 24px;
      box-shadow: $shadow-sm;
      backdrop-filter: blur(8px);
    }

    .main-title {
      font-size: clamp(32px, 4vw, 46px);
      font-weight: 700;
      margin: 0 0 24px;
      line-height: 1.25;
      color: $text-main;

      .color-text {
        background: linear-gradient(90deg, #3490f3 0%, #f2a738 100%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }
    }

    .desc {
      font-size: 16px;
      color: $text-sub;
      margin-bottom: 36px;
      line-height: 1.85;
    }

    .btn-group {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 40px;
    }

    .bottom-info {
      display: flex;
      flex-wrap: wrap;
      gap: 32px;
      align-items: center;

      .info-item {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        color: $text-sub;

        .info-item-group {
          display: flex;
          align-items: center;

          div {
            margin-left: -6px;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            overflow: hidden;
            border: 2px solid #fff;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

            &:first-child {
              margin-left: 0;
            }

            &:nth-child(1) span {
              background: linear-gradient(135deg, #3488f0, #5ba0f5);
            }

            &:nth-child(2) span {
              background: linear-gradient(135deg, #f79420, #ffb347);
            }

            &:nth-child(3) span {
              background: linear-gradient(135deg, #e84880, #ff6b9d);
            }

            &:nth-child(4) span {
              background: linear-gradient(135deg, #9955dd, #b87dff);
            }

            &:nth-child(5) span {
              background: linear-gradient(135deg, #32b4a2, #5dd4c4);
            }

            span {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .star {
        color: #ffb800;
        letter-spacing: 2px;
        font-size: 14px;
      }
    }
  }

  .banner-right {
    flex: 1;
    max-width: 560px;
    position: relative;
    z-index: 1;

    .cube-box {
      position: relative;
      overflow: hidden;

      .img-placeholder {
        width: 100%;
        aspect-ratio: 1 / 0.85;
        max-height: 460px;
        background: linear-gradient(145deg, #e8f0ff 0%, #f0f5ff 100%);
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: $shadow-md;
        border: 1px solid rgba(255, 255, 255, 0.8);
      }

      .banner-img {
        width: 80%;
        height: 80%;
        object-fit: contain;
        filter: drop-shadow(0 20px 34px rgba(0, 0, 0, 0.15)) drop-shadow(0 0 18px rgba(191, 219, 254, 0.3));
        animation: bannerFloat 4.8s ease-in-out infinite;
      }

      .tip-tag {
        position: absolute;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 14px;
        padding: 14px 18px;
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 13px;
        color: $text-sub;
        box-shadow: $shadow-md;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.6);
        transition: transform $transition;

        &:hover {
          transform: translateY(-3px);
        }

        .num {
          font-size: 22px;
          font-weight: 700;
          color: $text-main;
          line-height: 1.2;
        }
      }

      .tip-left {
        top: 24px;
        left: 12px;

        .green-check {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          background: linear-gradient(135deg, #27c060, #3dd87a);
          border-radius: 12px;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(39, 192, 96, 0.35);

          i {
            font-size: 22px;
            color: white;
          }
        }
      }

      .tip-right {
        bottom: 32px;
        right: 12px;

        .orange-light {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          background: linear-gradient(135deg, #ff782e, #ff9a5c);
          border-radius: 12px;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(255, 120, 46, 0.35);

          i {
            font-size: 22px;
            color: white;
          }
        }
      }
    }
  }
}

// 2. 四大核心能力
.core-ability-section {
  .ability-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .ability-card {
      background: #fff;
      padding: 28px 24px;
      border-radius: $radius-lg;
      position: relative;
      border: 1px solid #eef2f8;
      box-shadow: $shadow-sm;
      transition: transform $transition, box-shadow $transition, border-color $transition;
      --icon-color-rgb: 200, 200, 200;

      .icon {
        width: 52px;
        height: 52px;
        border-radius: 14px;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform $transition, box-shadow $transition;
      }

      .icon i {
        font-size: 22px;
        color: #fff;
      }

      .blue-icon {
        background: linear-gradient(135deg, #3488f0, #5ba0f5);
      }

      .purple-icon {
        background: linear-gradient(135deg, #9c78e3, #b99aef);
      }

      .green-icon {
        background: linear-gradient(135deg, #32b4a2, #4dd4c0);
      }

      .orange-icon {
        background: linear-gradient(135deg, #ff782e, #ff9a5c);
      }

      &:has(.blue-icon) {
        --icon-color-rgb: 52, 136, 240;
      }

      &:has(.purple-icon) {
        --icon-color-rgb: 156, 120, 227;
      }

      &:has(.green-icon) {
        --icon-color-rgb: 50, 180, 162;
      }

      &:has(.orange-icon) {
        --icon-color-rgb: 255, 120, 46;
      }

      .num {
        position: absolute;
        top: 24px;
        right: 24px;
        font-size: 40px;
        color: #eef2f8;
        font-weight: 700;
        line-height: 1;
      }

      h3 {
        font-size: 18px;
        font-weight: 600;
        margin: 0 0 10px;
        color: $text-main;
      }

      p {
        font-size: 13px;
        color: $text-sub;
        line-height: 1.75;
        margin: 0;
        text-align: justify;
      }

      &:hover {
        transform: translateY(-8px);
        border-color: rgba(var(--icon-color-rgb), 0.3);
        box-shadow: 0 12px 32px rgba(var(--icon-color-rgb), 0.18);

        .icon {
          transform: translateY(-4px) scale(1.05);
          box-shadow: 0 6px 16px rgba(var(--icon-color-rgb), 0.35);
        }
      }
    }
  }
}

// 3. 技术优势
.function-section {
  background: linear-gradient(180deg, #fafbff 0%, #fff 100%);
  max-width: 100%;
  padding-left: 0;
  padding-right: 0;

  .section-header {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 24px;
  }
}

.tech-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  background: #f5f8ff;
  border-radius: 20px;
  border: 1px solid #e8eef8;
}

.left-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.module-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 18px 16px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all $transition;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  &:hover {
    box-shadow: $shadow-sm;
    border-color: #dce6ff;
  }

  &.active {
    border-color: $primary;
    background: linear-gradient(135deg, #fff 0%, #f0f6ff 100%);
    box-shadow: $shadow-md;

    .card-icon {
      background: linear-gradient(135deg, $primary, #5ba0f5) !important;

      i {
        color: #fff !important;
      }
    }

    .card-title {
      color: $primary;
    }

    .card-tag {
      background: $primary-light;
      color: $primary;
    }
  }
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all $transition;

  i {
    font-size: 22px;
    color: $primary;
    transition: all $transition;
  }
}

.card-content {
  flex: 1;
  margin-left: 14px;
  min-width: 0;

  .card-title {
    font-size: 17px;
    font-weight: 600;
    color: $text-main;
    margin-bottom: 4px;
    transition: color $transition;
  }

  .card-desc {
    font-size: 13px;
    color: $text-sub;
    line-height: 1.65;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.card-tag {
  background: #f1f5f9;
  color: #94a3b8;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  flex-shrink: 0;
  align-self: flex-start;
  transition: all $transition;
  position: absolute;
  right: 10px;
  top: 10px;
}

.right-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 480px;
  border-radius: $radius-lg;
  overflow: hidden;
  background-image: linear-gradient(rgba(255, 255, 255, 0.12) 1px, transparent 1px),
  linear-gradient(90deg, rgba(255, 255, 255, 0.12) 1px, transparent 1px),
  linear-gradient(145deg, #3d6ee8 0%, #24b8ff 100%);
  background-size: 24px 24px, 24px 24px, 100% 100%;
  box-shadow: $shadow-lg;

  .panel-header {
    padding: 24px 28px 16px;
    flex-shrink: 0;
  }

  .panel-title {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 8px;
  }

  .panel-desc {
    font-size: 14px;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
  }

  .panel-visual {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px 24px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      max-height: 360px;
      object-fit: contain;
      border-radius: 10px;
      animation: imgBreath 4s ease-in-out infinite alternate;
      filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.15));
      transition: transform 0.4s ease, filter 0.4s ease;
    }
  }

  &:hover .panel-visual img {
    animation-play-state: paused;
    transform: scale(1.03);
    filter: drop-shadow(0 12px 32px rgba(0, 0, 0, 0.2));
  }
}

// 4. 应用场景
.scene-section {
  max-width: 100%;
  padding-left: clamp(16px, 3vw, 48px);
  padding-right: clamp(16px, 3vw, 48px);

  .scene-list {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;

    .scene-card {
      flex: 1;
      min-width: 0;
      background: #fff;
      border-radius: $radius-lg;
      border: 1px solid #eef2f8;
      box-shadow: $shadow-sm;
      overflow: hidden;
      transition: transform $transition, box-shadow $transition, border-color $transition;
      cursor: default;

      .scene-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px 0 10px;

        i {
          background: #f1f3fe;
          padding: 12px;
          border-radius: 12px;
          color: #3488f0;
          font-size: 20px;
          transition: all $transition;
        }
      }

      h3 {
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        margin: 0 0 6px;
        color: $text-main;
        transition: color $transition;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 8px;
      }

      p {
        font-size: 12px;
        color: $text-sub;
        padding: 0 10px 16px;
        margin: 0;
        text-align: center;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &:hover {
        transform: translateY(-6px);
        border-color: rgba(73, 120, 242, 0.4);
        box-shadow: $shadow-md;

        h3 {
          color: $primary;
        }

        i {
          background: linear-gradient(135deg, #4978f2, #5ba0f5);
          color: #fff;
          box-shadow: 0 4px 12px rgba(73, 120, 242, 0.35);
        }
      }
    }
  }

  .scene-more {
    text-align: center;
    margin-top: 8px;

    div:nth-child(1) {
      margin: 36px 0 20px;
      font-size: 15px;
      color: $text-sub;
    }
  }
}

// 5. 数据板块
.data-section {
  max-width: 100%;
  background: linear-gradient(135deg, #2a6fd4 0%, #3488f0 50%, #5ba0f5 100%);
  padding: 72px 24px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.06) 0%, transparent 40%);
    pointer-events: none;
  }

  .section-header {
    position: relative;
    margin-bottom: 48px;
  }

  .data-list {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    position: relative;

    .data-card {
      text-align: center;
      background: rgba(255, 255, 255, 0.12);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: $radius-lg;
      padding: 36px 20px;
      backdrop-filter: blur(8px);
      transition: transform $transition, background $transition;
      width: 150px;

      &:hover {
        transform: translateY(-4px);
        background: rgba(255, 255, 255, 0.18);
      }

      .big-num {
        font-size: clamp(36px, 4vw, 48px);
        color: #fff;
        font-weight: 700;
        line-height: 1;
        margin-bottom: 12px;
        font-variant-numeric: tabular-nums;
      }

      .data-label {
        color: rgba(255, 255, 255, 0.85);
        font-size: 16px;
      }
    }
  }
}

// 响应式
@media (max-width: 1100px) {
  .banner-section {
    flex-direction: column;
    padding: 60px 24px;
    min-height: auto;

    .banner-left,
    .banner-right {
      max-width: 100%;
      width: 100%;
    }

    .cube-box .tip-left {
      left: 8px;
    }

    .cube-box .tip-right {
      right: 8px;
    }
  }

  .core-ability-section .ability-list {
    grid-template-columns: repeat(2, 1fr);
  }

  .data-section .data-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  section {
    padding: 48px 16px;
  }

  .section-header .section-title {
    font-size: 26px;
  }

  .core-ability-section .ability-list,
  .data-section .data-list {
    grid-template-columns: 1fr;
  }

  .scene-section .scene-list {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;

    .scene-card {
      flex: 0 0 calc((100% - 96px) / 7);
      min-width: 120px;
    }
  }

  .tech-container {
    padding: 16px;
  }
}
</style>

<style>
@keyframes imgBreath {
  0% {
    transform: scale(0.96);
  }
  100% {
    transform: scale(1.01);
  }
}

@keyframes bannerFloat {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-14px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
